export default function PHP_echo() {
  return (
    <div>
      <h1>PHP_echo</h1>
    </div>
  );
}
